import React from "react";

export default function Footer() {
  return (
    <div>
      <div className="container-fluid footer-section text-center">
        <h3 className="mb-4 mt-2">
          <span className="spanhealthier"> Stay Fit, Stay Healthy </span>{" "}
        </h3>
        <p>
          Your fitness journey starts here. <br /> Get ready to transform your
          body and mind with our exclusive gym workouts.
        </p>

        <p className="mb-0">
          &copy; 2024 Fitness Junction. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}
